import React from 'react';
import ChessPic from '@/assets/ChessPic.png';
import '@/css/Variation.css'

type ModalProps = {
  isVariationHelpModalOpen: boolean;
  onClose: () => void;
};

const VariationModal: React.FC<ModalProps> = ({ isVariationHelpModalOpen, onClose}) => {
  if (!isVariationHelpModalOpen) return null;

  return (
    <div className="popup fadeout">
    <div className="popup closeLayer"></div>
    <div className="container">
    <div style={{ display: 'flex',justifyContent: 'space-between'}}>
        <h3>Chess Variation Help</h3>
        <button onClick={onClose}>
            <svg width={15} aria-hidden="true" style={{ color: '236,240,241' }} focusable="false" data-prefix="fas" data-icon="xmark" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path fill="currentColor" d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"></path></svg>
        </button>
      </div>
      <div className="modalItemContainer">
        <div className="item">
          <img width={122} height={122} alt="Tutorial game screenshot" src={ChessPic} className="image left"/>
          <div>
            <h3 className="title">Standard Chess (Classic)</h3>
            <div className="fw4">
              The traditional version of chess: both players begin from the standard starting position and win by checkmating the opponent’s king.
            </div>
            <div className="fw4 mt3">
              All standard chess rules apply, including castling, en passant, pawn promotion, stalemate, and draws by repetition or insufficient material.
            </div>
          </div>
        </div>
        <div className="item">
          <img width={122} height={122} alt="Tutorial game screenshot" src={ChessPic} className="image left"/>
          <div>
            <h3 className="title">King of the Hill – Objective</h3>
            <div className="fw4">
                In this chess variant, the goal is not just checkmate — you win by moving your king to one of the four central squares: <strong>e4, d4, e5, or d5</strong>.
            </div>
            <div className="fw4 mt3">
                All standard chess rules apply, but players must balance defending their king while also advancing it toward the center. Positioning and control of the central area become even more critical than in traditional chess.
            </div>
          </div>
        </div>
        <div className="item">
          <img width={122} height={122} alt="Tutorial game screenshot" src={ChessPic} className="image left"/>
          <div>
            <h3 className="title">Chess960 (Fischer Random Chess)</h3>
            <div className="fw4">
              The starting position of the pieces on the back rank is randomized (with some constraints) to encourage creativity and reduce opening theory memorization.
            </div>
            <div className="fw4 mt3">
              All standard chess rules apply, but the unusual starting setups force players to rely more on intuition and adaptability from the first move.
            </div>
          </div>
        </div>
        <div className="item">
          <img width={122} height={122} alt="Tutorial game screenshot" src={ChessPic} className="image left"/>
          <div>
            <h3 className="title">Three-Check Chess</h3>
            <div className="fw4">
              The first player to deliver three checks to the opponent’s king wins the game, regardless of checkmate.
            </div>
            <div className="fw4 mt3">
              Players must carefully balance offense and defense, as giving up checks can quickly lead to defeat.
            </div>
          </div>
        </div>
        
      </div>
    </div>
  </div>
  );
};

export default VariationModal;
